import React from "react";

import { withRouter } from "react-router";

import { inject } from "mobx-react";

import { Helmet } from "react-helmet";

import locales from "../utils/locales";

const mapper = (stores, props) => ({
  intl: locales[props.match.params.locale || stores.uiStore.getLocale.get()]
});

export default withRouter(
  inject(mapper)(({ intl }) => (
    <Helmet>
      <title>{intl.TAB}</title>
      <meta name="name" content={intl.TAB} />
      <meta name="copyright" content={intl.TAB} />
      <meta name="url" content={intl.SITE_URL} />
      <meta property="og:title" content={intl.TAB} />
      <meta property="og:description" content={intl.SITE_DESCRIPTION} />
    </Helmet>
  ))
);



// WEBPACK FOOTER //
// ./src/components/Head.js